import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// components
import SettingsIcon from '@mui/icons-material/Settings';
import BarChartIcon from '@mui/icons-material/BarChart';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import FactoryIcon from '@mui/icons-material/Factory';
import HandshakeIcon from '@mui/icons-material/Handshake';
import ShapeLineIcon from '@mui/icons-material/ShapeLine';
import InventoryIcon from '@mui/icons-material/Inventory';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { useTranslation } from 'react-i18next';
import { removeNoAuth, useInitializePermissions } from './utils';
// ----------------------------------------------------------------------1

export function useNavDataVertical() {
  const [t] = useTranslation('global');

  const policies = useInitializePermissions();

  const data = useMemo(
    () => [
      {
        subheader: '',
        items: [
          {
            title: 'CRM',
            path: paths.dashboard.crm.root,
            icon: <HandshakeIcon />,
            children: [
              {
                title: t('project-key-words.cliente', 'Cliente'),
                path: paths.dashboard.crm.cliente,
                viewName: 'Cliente',
              },
              {
                title: t('project-key-words.proveedor', 'Proveedor'),
                path: paths.dashboard.crm.proveedor,
                viewName: 'Proveedor',
              },
              {
                title: t('project-key-words.contacto', 'Contactos'),
                path: paths.dashboard.crm.contacto,
                viewName: 'Contacto',
              },
              {
                title: 'Parámetros',
                path: paths.dashboard.crm.parametros,
                viewName: 'ParametrosCRM',
              },
            ],
          },
        ],
      },
      {
        subheader: '',
        items: [
          {
            title: t('project-key-words.ventas', 'Ventas'),
            path: paths.dashboard.ventas.root,
            icon: <ReceiptIcon />,
            children: [
              {
                title: 'Cotización',
                path: paths.dashboard.ventas.cotizacion,
                viewName: 'Cotizacion',
              },
            ],
          },
        ],
      },
      {
        subheader: '',
        items: [
          {
            title: 'Producción',
            path: paths.dashboard.produccion.root,
            icon: <FactoryIcon />,
            children: [
              {
                title: 'Orden de Producción',
                path: paths.dashboard.produccion.orden,
                viewName: 'Orden',
              },
              // {
              //   title: 'Proyectos',
              //   path: paths.dashboard.produccion.proyecto,
              //   viewName: 'Proyecto',
              // },
              //COMENTADO PORQUE NO HAY NADA EN PARAMS
              // {
              //   title: 'Parámetros',
              //   path: paths.dashboard.produccion.parametros,
              //   viewName: 'ParametrosProduccion',
              // },
            ],
          },
        ],
      },

      {
        subheader: '',
        items: [
          {
            title: t('project-key-words.compras', 'Compras'),
            path: paths.dashboard.compras.root,
            icon: <InventoryIcon />,
            children: [
              {
                title: t('project-key-words.compras', 'Compras'),
                path: paths.dashboard.compras.compras,
                viewName: 'Compras',
              },
              {
                title: 'Insumos',
                path: paths.dashboard.compras.insumo,
                viewName: 'Insumo',
              },
              {
                title: t('project-key-words.certificado', 'Certificado'),
                path: paths.dashboard.compras.certificado,
                viewName: 'Certificado',
              },
              {
                title: 'Parámetros',
                path: paths.dashboard.compras.parametros,
                viewName: 'ParametrosCompras',
              },
            ],
          },
        ],
      },

      {
        subheader: '',
        items: [
          {
            title: 'Facturación',
            path: paths.dashboard.facturacion.root,
            icon: <RequestQuoteIcon />,
            children: [
              {
                title: 'Facturación',
                path: paths.dashboard.facturacion.facturacion,
                viewName: 'Facturacion',
              },
              {
                title: t('project-key-words.recibo', 'Recibo'),
                path: paths.dashboard.facturacion.recibo,
                viewName: 'Recibo',
              },
              {
                title: t('project-key-words.remito', 'Remito'),
                path: paths.dashboard.facturacion.remito,
                viewName: 'Remito',
              },
              {
                title: 'Parámetros',
                path: paths.dashboard.facturacion.parametros,
                viewName: 'ParametrosFacturacion',
              },
            ],
          },
        ],
      },

      {
        subheader: '',
        items: [
          {
            title: t('project-key-words.productos', 'Productos'),
            icon: <ShapeLineIcon />,
            path: paths.dashboard.productos.root,
            children: [
              {
                title: 'Matriz/Producto',
                path: paths.dashboard.productos.matrizProducto,
                viewName: 'MatrizProductoView',
              },
              {
                title: t('project-key-words.producto', 'Producto'),
                path: paths.dashboard.productos.producto,
                viewName: 'Producto',
              },
              {
                title: t('project-key-words.matriz', 'Matriz'),
                path: paths.dashboard.productos.matriz,
                viewName: 'Matriz',
              },

              {
                title: 'Formulación Compuesto',
                path: paths.dashboard.productos.formulacionCompuesto,
                viewName: 'FormulacionCompuesto',
              },

              {
                title: 'Parámetros',
                path: paths.dashboard.productos.parametros,
                viewName: 'ParametrosProductos',
              },
            ],
          },
        ],
      },
      // {
      //   subheader: '',
      //   items: [
      //     {
      //       title: t('project-key-words.kPIs', 'KPIs'),
      //       icon: <BarChartIcon />,
      //       path: paths.dashboard.kPIs,
      //       viewName: 'KPIs',
      //     },
      //   ],
      // },

      // SETTINGS
      // ----------------------------------------------------------------------
      {
        isSettings: true,
        subheader: '',
        items: [
          {
            title: t('account-menu.settings'),
            path: '/dashboard/settings',
            icon: <SettingsIcon />,
            children: [
              {
                title: t('settings.roles'),
                path: '/dashboard/settings/roles',
                viewName: 'Role',
              },
              {
                title: t('settings.users'),
                path: '/dashboard/settings/users',
                viewName: 'User',
              },
              {
                title: t('settings.parameters'),
                path: '/dashboard/settings/parameters',
                viewName: 'Parameter',
              },
              {
                title: 'Mensajes',
                path: '/dashboard/settings/mensaje',
                viewName: 'Mensaje',
              },
              {
                title: t('settings.jobs'),
                path: '/dashboard/settings/jobs',
                viewName: 'Job',
              },
              {
                title: t('settings.log-viewer'),
                path: '/dashboard/settings/logviewer',
                viewName: 'LogViewer',
              },
            ],
          },
        ],
      },
    ],
    [t]
  );

  return removeNoAuth(data, policies);
}

export function useNavData() {
  const policies = useInitializePermissions();
  const [t] = useTranslation('global');

  const data = useMemo(
    () => [
      {
        subheader: '',
        items: [
          {
            title: 'CRM',
            path: paths.dashboard.crm.root,
            children: [
              {
                title: t('project-key-words.cliente', 'Cliente'),
                path: paths.dashboard.crm.cliente,
                viewName: 'Cliente',
              },
              {
                title: t('project-key-words.proveedor', 'Proveedor'),
                path: paths.dashboard.crm.proveedor,
                viewName: 'Proveedor',
              },
              {
                title: t('project-key-words.contacto', 'Contactos'),
                path: paths.dashboard.crm.contacto,
                viewName: 'Contacto',
              },
              {
                title: 'Parámetros',
                path: paths.dashboard.crm.parametros,
                viewName: 'ParametrosCRM',
              },
            ],
          },
        ],
      },
      {
        subheader: '',
        items: [
          {
            title: t('project-key-words.ventas', 'Ventas'),
            path: paths.dashboard.ventas.root,
            children: [
              {
                title: 'Cotización',
                path: paths.dashboard.ventas.cotizacion,
                viewName: 'Cotizacion',
              },
              {
                title: t('project-key-words.cliente', 'Cliente'),
                path: paths.dashboard.ventas.cliente,
                viewName: 'Cliente',
              },
            ],
          },
        ],
      },
      {
        subheader: '',
        items: [
          {
            title: 'Producción',
            path: paths.dashboard.produccion.root,
            children: [
              {
                title: 'Orden de Producción',
                path: paths.dashboard.produccion.orden,
                viewName: 'Orden',
              },
              // {
              //   title: 'Proyectos',
              //   path: paths.dashboard.produccion.proyecto,
              //   viewName: 'Proyecto',
              // },
              // {
              //   title: 'Produccion',
              //   path: paths.dashboard.produccion.produccion,
              //   viewName: 'Produccion',
              // },
              // {
              //   title: 'Parámetros',
              //   path: paths.dashboard.produccion.parametros,
              //   viewName: 'ParametrosProduccion',
              // },
            ],
          },
        ],
      },
      {
        subheader: '',
        items: [
          {
            title: t('project-key-words.compras', 'Compras'),
            path: paths.dashboard.compras.root,
            children: [
              {
                title: t('project-key-words.compras', 'Compras'),
                path: paths.dashboard.compras.compras,
                viewName: 'Compras',
              },
              {
                title: 'Insumos',
                path: paths.dashboard.compras.insumo,
                viewName: 'Insumo',
              },
              {
                title: t('project-key-words.certificado', 'Certificado'),
                path: paths.dashboard.compras.certificado,
                viewName: 'Certificado',
              },
              {
                title: 'Parámetros',
                path: paths.dashboard.compras.parametros,
                viewName: 'ParametrosCompras',
              },
            ],
          },
        ],
      },

      {
        subheader: '',
        items: [
          {
            title: 'Facturación',
            path: paths.dashboard.facturacion.root,
            children: [
              {
                title: 'Facturación',
                path: paths.dashboard.facturacion.facturacion,
                viewName: 'Facturacion',
              },

              {
                title: t('project-key-words.remito', 'Remito'),
                path: paths.dashboard.facturacion.remito,
                viewName: 'Remito',
              },
              {
                title: t('project-key-words.recibo', 'Recibo'),
                path: paths.dashboard.facturacion.recibo,
                viewName: 'Recibo',
              },
              {
                title: 'Parámetros',
                path: paths.dashboard.facturacion.parametros,
                viewName: 'ParametrosFacturacion',
              },
            ],
          },
        ],
      },

      {
        subheader: '',
        items: [
          {
            title: t('project-key-words.productos', 'Productos'),
            path: paths.dashboard.productos.root,
            children: [
              {
                title: 'Matriz/Producto',
                path: paths.dashboard.productos.matrizProducto,
                viewName: 'MatrizProducto',
              },
              {
                title: t('project-key-words.producto', 'Producto'),
                path: paths.dashboard.productos.producto,
                viewName: 'Producto',
              },
              {
                title: t('project-key-words.matriz', 'Matriz'),
                path: paths.dashboard.productos.matriz,
                viewName: 'Matriz',
              },

              {
                title: 'Formulación Compuesto',
                path: paths.dashboard.productos.formulacionCompuesto,
                viewName: 'FormulacionCompuesto',
              },

              {
                title: 'Parámetros',
                path: paths.dashboard.productos.parametros,
                viewName: 'ParametrosProductos',
              },
            ],
          },
        ],
      },

      {
        subheader: '',
        items: [
          {
            title: t('project-key-words.mensaje', 'Mensajes'),
            path: paths.dashboard.mensaje,
            viewName: 'Mensaje',
          },
        ],
      },

      {
        subheader: '',
        items: [
          {
            title: t('project-key-words.kPIs', 'KPIs'),
            path: paths.dashboard.kPIs,
            viewName: 'KPIs',
          },
        ],
      },
    ],
    [t]
  );

  return removeNoAuth(data, policies);
}
